/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CharterBlock = {
    Honesty: 'honesty',
    Professionalism: 'professionalism',
    Subcontracting: 'subcontracting',
    Bypass: 'bypass',
    Rating: 'rating',
    Discrimination: 'discrimination'
} as const;
export type CharterBlock = typeof CharterBlock[keyof typeof CharterBlock];


export function instanceOfCharterBlock(value: any): boolean {
    for (const key in CharterBlock) {
        if (Object.prototype.hasOwnProperty.call(CharterBlock, key)) {
            // @ts-ignore
            if (CharterBlock[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CharterBlockFromJSON(json: any): CharterBlock {
    return CharterBlockFromJSONTyped(json, false);
}

export function CharterBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): CharterBlock {
    return json as CharterBlock;
}

export function CharterBlockToJSON(value?: CharterBlock | null): any {
    return value as any;
}

